export default {"src":"/_next/static/media/commercial-land-icon-selected.cb5f54eb.svg","height":110,"width":108,"blurWidth":0,"blurHeight":0};